import React from 'react';
import {
  Flex,
  useColorMode,
  useIsMobileView,
  Text,
  typography,
  color,
  StyleProps,
} from 'deepstash-ui';
import { StoryApiResponse } from 'api/api.types';
import StoriesCarousel from 'src/components/story/StoriesCarousel';

interface StoryPageRelatedStoriesProps {
  stories: StoryApiResponse[];
}

const StoryPageRelatedStories: React.FC<
  StoryPageRelatedStoriesProps & StyleProps
> = ({ stories, ...props }) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  return (
    <Flex width={'100%'} flexDirection="column" {...props}>
      <Text
        {...typography.primaryHeadingFonts.medium.bold}
        color={color[colorMode].text}
        {...(isMobileView ? { ml: 16 } : {})}
      >
        {'Related Stories'}
      </Text>
      <StoriesCarousel stories={stories} mt={16} />
    </Flex>
  );
};

export default StoryPageRelatedStories;
